import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  Modal,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import AddUpdateSpaceConfig from "./AddUpdateSpaceConfig";
import { useState } from "react";
import { useEffect } from "react";
import {
  handleSpringDataMutationRequest,
  handleSpringDataRequest,
} from "../../../../api";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import { SecondaryButton } from "../../../../Utils/ButtonHelper";
import CloseIcon from "@mui/icons-material/Close";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.common.black,
    backgroundColor: "#36454F",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 2,
};

export default function Configuration({
  singleSpaceInfo,
  setOpenConfiguration,
  setGridRefresh,
}) {
  const [openAddEditConfig, setOpenAddEditConfig] = useState(false);
  const [openDeleteConfig, setOpenDeleteConfig] = useState(false);
  const [spaceRooms, setSpaceRooms] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState({});
  useEffect(() => {
    if (!openAddEditConfig) {
      setSelectedRoom({});
      handleSpringDataRequest(
        `core/api/v1/non-rental/get-non-rental-by-type-id/?typeId=${singleSpaceInfo?.id}`
      )
        .then((res) => {
          setSpaceRooms(res);
        })
        .catch((err) => {});
    }
  }, [singleSpaceInfo, openAddEditConfig]);

  const handleDeleteRoom = () => {
    handleSpringDataMutationRequest(``);
  };
  return (
    <Box sx={{ width: 800, p: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Button
          variant="custom-button"
          onClick={() => setOpenAddEditConfig(true)}
        >
          Add new {singleSpaceInfo?.name} room
        </Button>
        <IconButton onClick={() => setOpenConfiguration(false)}>
          <CloseIcon />
        </IconButton>
      </Box>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Name</StyledTableCell>
              <StyledTableCell align="right">Per hour cost</StyledTableCell>
              <StyledTableCell align="right">Per person cost</StyledTableCell>
              <StyledTableCell align="right">Status</StyledTableCell>
              <StyledTableCell align="right">Edit</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {spaceRooms.map((room) => (
              <StyledTableRow key={room?.id}>
                <StyledTableCell component="th" scope="row">
                  {room?.name}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {room?.perHourCost}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {room?.perPersonCost}
                </StyledTableCell>
                <StyledTableCell align="right">{room?.status}</StyledTableCell>
                <StyledTableCell align="right">
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}
                  >
                    <Box sx={{ display: "flex", gap: 1, flexDirection: "row" }}>
                      <Tooltip title="Update">
                        <IconButton
                          onClick={() => {
                            setSelectedRoom(room);
                            setOpenAddEditConfig(true);
                          }}
                        >
                          <BorderColorIcon />
                        </IconButton>
                      </Tooltip>
                      {/* <Tooltip title="View">
                        <IconButton onClick={() => setSelectedRoom(room)}>
                          <ContentPasteIcon />
                        </IconButton>
                      </Tooltip> */}

                      {/* <Tooltip title="Delete">
                        <IconButton
                          onClick={() => {
                            setSelectedRoom(room);
                            setOpenDeleteConfig(true);
                          }}
                        >
                          <DeleteForeverIcon />
                        </IconButton>
                      </Tooltip> */}
                    </Box>
                  </Box>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Drawer
        anchor={"right"}
        open={openAddEditConfig}
        // onClose={() => setOpenAddEditConfig(false)}
      >
        <AddUpdateSpaceConfig
          setOpenAddEditConfig={setOpenAddEditConfig}
          singleSpaceInfo={singleSpaceInfo}
          selectedRoom={selectedRoom}
          setGridRefresh={setGridRefresh}
        />
      </Drawer>
      <Modal
        open={openDeleteConfig}
        // onClose={() => setOpenDeleteConfig(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={modalStyle}>
          <Stack spacing={2}>
            <Stack className="justify-content-between" direction="row">
              <Typography variant="h6" style={{ fontSize: "12.5px" }}>
                Confirm to delete configured space
              </Typography>
              <IconButton>
                <CloseIcon onClick={() => setOpenDeleteConfig(false)} />
              </IconButton>
            </Stack>
            <Divider />
            <Stack>
              <Typography>
                Are you sure you want to delete the room{" "}
                <b>{selectedRoom?.name}</b> ?
              </Typography>
            </Stack>
            <Stack
              className="position-relative w-100 justify-content-between"
              direction="row"
            >
              <SecondaryButton
                text={"Cancel"}
                onClick={() => setOpenDeleteConfig(false)}
              />
              <Button variant="custom-button" onClick={handleDeleteRoom}>
                Confirm delete
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </Box>
  );
}
